import * as React from "react";
import { Box, IconButton } from "@mui/material";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

const ButtonImport = (props) => {
  return (
    <IconButton
      onClick={props.onClick}
      sx={{
        height: 48,
        width: 48,
        backgroundColor: props.disabled ? "rgba(0,0,0,0.38)" : "rgb(6 191 166)",
        color: "#fff",
        borderRadius: "8px",
        marginRight: "4px",
        "&.MuiButtonBase-root.MuiIconButton-root:hover": {
          backgroundColor: "rgb(4 121 106)",
        },
        "&.MuiButtonBase-root.MuiIconButton-root.Mui-disabled": {
          backgroundColor: props.disabled ? "rgba(0,0,0,0.38)" : "#036288",
        },
      }}
      {...props}
    >
      <DriveFolderUploadIcon
        sx={{
          color: "#fff",
          "&.MuiSvgIcon-root": {
            height: "30px",
            width: "30px",
          },
        }}
      />
    </IconButton>
  );
};

export default ButtonImport;
